export const projectVideo = {
  poster: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1920 1080'%3E%3Crect fill='%23e5e7eb' width='1920' height='1080'/%3E%3C/svg%3E",
  title: '点滴公益宣传片',
};

export const projectDetails = [
  {
    title: '项目背景与目标',
    icon: 'ri-flag-line',
    content: '在炎炎夏日,城市一线工作者在高温下坚守岗位,为城市的正常运转付出辛勤汗水。"点滴公益"旨在为这些平凡英雄送去清凉与关怀,让他们感受到社会的温暖与尊重。我们的目标是覆盖重庆市所有区县,每年为超过10万名一线工作者提供免费饮用水。',
  },
  {
    title: '服务对象',
    icon: 'ri-user-heart-line',
    content: '环卫工人、快递员、外卖骑手、建筑工人、交通协管员、保安、绿化工人等在高温环境下工作的一线劳动者。我们优先服务于收入较低、工作环境艰苦的群体,确保爱心资源精准送达。',
  },
  {
    title: '捐赠模式',
    icon: 'ri-hand-heart-line',
    content: '我们采用透明化捐赠模式:19.9元可为一线工作者提供12瓶优质矿泉水。所有捐款将100%用于采购和配送,管理费用由合作企业赞助。每笔捐赠都会生成唯一编号,捐赠者可随时查询善款使用情况。',
  },
  {
    title: '执行流程',
    icon: 'ri-flow-chart',
    content: '1. 接收捐赠 → 2. 统一采购优质矿泉水 → 3. 联系受助单位确认需求 → 4. 志愿者配送到指定地点 → 5. 受助者签收确认 → 6. 公示配送记录与照片 → 7. 定期发布项目报告',
  },
];

export const mapData = {
  districts: [
    { name: '渝中区', bottles: 45000, color: '#2A7A62' },
    { name: '江北区', bottles: 52000, color: '#2A7A62' },
    { name: '南岸区', bottles: 68000, color: '#1E5A4A' },
    { name: '渝北区', bottles: 71000, color: '#1E5A4A' },
    { name: '巴南区', bottles: 38000, color: '#3A9A82' },
    { name: '九龙坡区', bottles: 55000, color: '#2A7A62' },
    { name: '沙坪坝区', bottles: 49000, color: '#2A7A62' },
    { name: '大渡口区', bottles: 32000, color: '#3A9A82' },
  ],
};

export const donationSources = [
  { name: '个人捐赠', value: 65, color: '#2A7A62' },
  { name: '企业捐赠', value: 28, color: '#F4B942' },
  { name: '公益组织', value: 7, color: '#E06B3D' },
];

export const monthlyData = [
  { month: '1月', bottles: 45000 },
  { month: '2月', bottles: 38000 },
  { month: '3月', bottles: 52000 },
  { month: '4月', bottles: 68000 },
  { month: '5月', bottles: 95000 },
  { month: '6月', bottles: 125000 },
];

export const testimonials = {
  recipients: [
    {
      id: 1,
      avatar: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect fill='%23e5e7eb' width='400' height='400'/%3E%3C/svg%3E",
      name: '李师傅',
      role: '环卫工人',
      story: '我在南岸区做环卫工作已经15年了,每年夏天最难熬。今年有了"点滴公益",志愿者定期给我们送水,让我觉得自己的工作被社会认可和尊重。这不仅是一瓶水,更是一份温暖的关怀,让我干活更有劲了!',
      date: '2026-06-20',
    },
    {
      id: 2,
      avatar: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect fill='%23e5e7eb' width='400' height='400'/%3E%3C/svg%3E",
      name: '王强',
      role: '快递员',
      story: '作为一名快递员,每天要送100多个包裹,夏天经常顾不上喝水。"点滴公益"的志愿者会在我们休息点放置免费的水,真的太贴心了!这让我感受到了社会的温暖,也更有动力为大家服务。',
      date: '2026-06-18',
    },
    {
      id: 3,
      avatar: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect fill='%23e5e7eb' width='400' height='400'/%3E%3C/svg%3E",
      name: '张师傅',
      role: '建筑工人',
      story: '在工地上干活,最怕的就是中暑。"点滴公益"不仅给我们送水,志愿者还会关心我们的身体状况。这份关怀让我们这些外来务工人员感到被尊重,也让我们更加热爱这座城市。',
      date: '2026-06-15',
    },
  ],
  donors: [
    {
      id: 1,
      avatar: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect fill='%23e5e7eb' width='400' height='400'/%3E%3C/svg%3E",
      name: '陈女士',
      role: '企业白领',
      story: '每次看到环卫工人在烈日下工作,我都很感动。通过"点滴公益",我可以用很小的金额帮助他们,而且整个过程透明公开,让我很放心。这是我参与公益最好的方式!',
      date: '2026-06-22',
    },
    {
      id: 2,
      avatar: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect fill='%23e5e7eb' width='400' height='400'/%3E%3C/svg%3E",
      name: '刘先生',
      role: '企业家',
      story: '作为企业家,我一直想为社会做些贡献。"点滴公益"的透明度和执行力让我印象深刻,我已经连续捐赠三个月了,还动员公司员工一起参与。看到那些感谢的笑脸,我觉得特别值得!',
      date: '2026-06-19',
    },
  ],
  volunteers: [
    {
      id: 1,
      avatar: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect fill='%23e5e7eb' width='400' height='400'/%3E%3C/svg%3E",
      name: '小美',
      role: '大学生志愿者',
      story: '参加"点滴公益"志愿服务是我大学生活最有意义的经历。每次看到工人师傅们接过水时感激的眼神,我都觉得自己做了一件很有价值的事。这个暑假我会继续参与!',
      date: '2026-06-21',
    },
  ],
};

export const partners = [
  { name: '重庆市南岸区慈善会', logo: '合作单位1' },
  { name: '南山宋窑', logo: '合作单位2' },
  { name: '爱心企业联盟', logo: '合作单位3' },
  { name: '重庆志愿者协会', logo: '合作单位4' },
  { name: '本地物流公司', logo: '合作单位5' },
  { name: '矿泉水生产企业', logo: '合作单位6' },
  { name: '社区服务中心', logo: '合作单位7' },
  { name: '媒体合作伙伴', logo: '合作单位8' },
];
